import React from 'react';
// import { DatePickerProps } from 'antd';
// import 'moment/locale/zh-cn';
import locale from 'antd/lib/date-picker/locale/pt_BR';
import { PickerProps } from 'antd/lib/date-picker/generatePicker';
import { Dayjs } from 'dayjs';

import {
  StyledAntdDatePicker,
} from './style';

const CVDatePicker = (props: PickerProps<Dayjs>): JSX.Element => (
  <StyledAntdDatePicker {...props} locale={locale} format="DD/MM/YYYY" />
);

export default CVDatePicker;
